import { useEffect, useState } from "react";

// 학습 지식 검토 — 챗봇이 회사 지식에 없는 질문을 받고 웹에서 자동 학습한 내용(pending)을
// 사람이 승인/거절한다. 승인해야 다음 채팅 답변에 근거로 쓰이고, 거절하면 인출에서 빠진다.
function LearnedReviewPanel({ onLoad, onSetStatus, onChanged }) {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState("");
  const [message, setMessage] = useState("");

  const load = async () => {
    setBusy("load");
    setMessage("");
    try {
      const data = await onLoad({ limit: 100 });
      setItems(data.items || []);
    } catch (err) {
      setMessage(err.message);
    } finally {
      setBusy("");
    }
  };

  const handleStatus = async (item, status) => {
    setBusy(`${status}:${item.id}`);
    setMessage("");
    try {
      await onSetStatus(item.id, status);
      setItems((prev) => prev.filter((it) => it.id !== item.id));
      setMessage(status === "approved"
        ? `승인했습니다 — "${item.title || item.id}". 이제 채팅 답변에 근거로 쓰입니다.`
        : `거절했습니다 — "${item.title || item.id}". 인출에서 제외됩니다.`);
      onChanged?.();
    } catch (err) {
      setMessage(err.message);
    } finally {
      setBusy("");
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isError = message && (message.includes("실패") || message.includes("못했") || message.includes("변경하지"));

  return (
    <section className="knowledge-panel">
      <div className="admin-panel-header">
        <div>
          <p className="panel-kicker">Learned Knowledge Review</p>
          <h3>학습 지식 검토 <span style={{ fontWeight: 400, opacity: 0.7 }}>({items.length}건 대기)</span></h3>
          <p>챗봇이 회사 지식에 없는 질문을 받고 웹에서 배운 내용입니다. <strong>승인</strong>해야 다음 답변에 근거로 쓰이고, <strong>거절</strong>하면 인출에서 빠집니다. 승인 전에는 사용자에게 노출되지 않습니다.</p>
        </div>
        <button className="admin-secondary-button" onClick={load} disabled={busy === "load"}>
          {busy === "load" ? "불러오는 중..." : "새로고침"}
        </button>
      </div>

      {message && <div className={isError ? "admin-error" : "admin-success"}>{message}</div>}

      <div className="knowledge-list">
        {busy === "load" && items.length === 0 && <div className="empty-panel">불러오는 중...</div>}
        {busy !== "load" && items.length === 0 && <div className="empty-panel">검토 대기 중인 학습 지식이 없습니다.</div>}
        {items.map((item) => (
          <article className="knowledge-item" key={item.id}>
            <div>
              <strong>{item.title || "제목 없음"}</strong>
              <span>
                질문: {item.question || "-"}
                {item.url ? <> · 출처: <a href={item.url} target="_blank" rel="noreferrer">{item.url}</a></> : null}
                {item.ts ? ` · ${item.ts}` : ""}
              </span>
              <p>{item.text || "내용 미리보기가 없습니다."}</p>
            </div>
            <div className="knowledge-learned-actions" style={{ display: "flex", flexDirection: "column", gap: 6, minWidth: 96 }}>
              <button className="admin-approve-button" onClick={() => handleStatus(item, "approved")} disabled={busy === `approved:${item.id}`}>
                {busy === `approved:${item.id}` ? "승인 중..." : "승인"}
              </button>
              <button className="admin-danger-button" onClick={() => handleStatus(item, "rejected")} disabled={busy === `rejected:${item.id}`}>
                {busy === `rejected:${item.id}` ? "거절 중..." : "거절"}
              </button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default LearnedReviewPanel;
